import React, { useState } from 'react'
import kslogo from '../../../../assets/images/ksloader.png'
import Steps from './components/Steps'
import StepOne from './components/StepOne'
import StepTwo from './components/StepTwo'
import StepThree from './components/StepThree'
import StepFour from './components/StepFour'
import StepFive from './components/StepFive'
import styles from './styles/stepOne.module.css'
import { X } from 'react-feather'
import { useDispatch } from 'react-redux'

const FirstLogin = ({ modal, setModal }) => {
  const [step, setStep] = useState(1)
  const dispatch = useDispatch()
  return (
    <div>
      {step === 5 && (
        <div className="d-flex justify-content-end mt-3 me-3">
          <X
            className={styles.closeModalButton}
            onClick={() => {
              setModal((prev) => ({ ...prev, first_login: false }))
              if (modal.complete_offices) {
                dispatch({ type: 'LOGIN_MODAL', payload: false })
              }
            }}
          />
        </div>
      )}
      <div
        className={`d-flex justify-content-center ${
          step === 5 ? 'mt-2' : 'mt-5'
        }`}
      >
        <img alt="foto" src={kslogo} width={150} />
      </div>
      {step === 1 && <StepOne setStep={setStep} />}
      {step === 2 && <StepTwo setStep={setStep} />}
      {step === 3 && <StepThree setStep={setStep} />}
      {step === 4 && <StepFour setStep={setStep} />}
      {step === 5 && (
        <StepFive setStep={setStep} setModal={setModal} modal={modal} />
      )}
      <div className="w-100 d-flex justify-content-center">
        <Steps step={step} setStep={setStep} />
      </div>
    </div>
  )
}

export default FirstLogin
